import React from 'react'
import config from '#src/app/config'
import { DepartmentConsumer } from '#src/app/context/department'
import { MaybeDepartment } from '#src/app/context/department/DepartmentContext'

export type SocialMedia = 'facebook' | 'instagram' | 'youtube'

interface Props extends React.HTMLProps<HTMLAnchorElement> {
  socialMedia: SocialMedia
}

const getSocialMediaLink = (activeDepartment: MaybeDepartment, socialMedia: SocialMedia) => {
  const categorySlug = activeDepartment ? activeDepartment.slug : 'default'
  let socialMediaLink: string | undefined
  let links: { [key: string]: string } | undefined

  if (socialMedia === 'facebook') {
    socialMediaLink = config.get('facebookLink')
  }

  if (socialMedia === 'instagram') {
    socialMediaLink = config.get('instagramLink')
  }

  if (socialMedia === 'youtube') {
    socialMediaLink = config.get('youtubeLink')
  }

  if (links && links[categorySlug]) {
    // Update to department specific link
    socialMediaLink = links[categorySlug]
    if (!socialMediaLink && links.default) {
      // Update to default in case department slug is not found
      socialMediaLink = links.default
    }
  }

  return socialMediaLink
}

const SocialMediaLink: React.FC<Props> = ({ children, socialMedia, ...props }) => (
  <DepartmentConsumer>
    {({ department }) => (
      <a {...props} href={getSocialMediaLink(department, socialMedia)}>
        {children}
      </a>
    )}
  </DepartmentConsumer>
)

export default SocialMediaLink
